import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title, 
  description, 
  keywords = '',
  canonicalUrl = '',
  ogImage = 'https://capitalbillingservices.com/assets/images/cbs-og-image.png',
  noindex = false
}) => {
  const siteTitle = 'Capital Billing Services';
  const branded = `${title} | ${siteTitle}`;
  const fullTitle = !title ? siteTitle : (title.includes('Capital Billing') || branded.length > 60 ? title : branded);
  const baseUrl = 'https://capitalbillingservices.com';
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={`${baseUrl}${canonicalUrl}`} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Capital Billing Services" />
      {canonicalUrl && <meta property="og:url" content={`${baseUrl}${canonicalUrl}`} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Robots */}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta name="author" content="Capital Billing Services" />
      
      {/* Geo targeting for US */}
      <meta name="geo.region" content="US" />
      <meta name="geo.placename" content="Atlanta, Georgia" />
    </Helmet>
  );
};
